import { StyleSheet } from 'react-native';

// Estilos auto-contidos da slice (literais); cores dinâmicas chegam via props.
export const styles = StyleSheet.create({
  wrap: { gap: 12 },

  // ── Segmented control "Posts | Vídeos" ──
  segment: {
    flexDirection: 'row',
    alignSelf: 'flex-start',
    backgroundColor: 'rgba(255,255,255,0.06)',
    borderRadius: 12,
    padding: 4,
    gap: 4,
  },
  segmentBtn: {
    paddingHorizontal: 18,
    paddingVertical: 8,
    borderRadius: 9,
  },
  segmentBtnActive: { backgroundColor: '#5B8FF9' },
  segmentText: { fontSize: 14, fontWeight: '700' },

  loader: { paddingVertical: 28 },
  empty: { paddingVertical: 20, fontSize: 14, textAlign: 'center' },

  // ── Card de post ──
  card: {
    borderRadius: 14,
    padding: 14,
    gap: 8,
    borderWidth: 1,
    borderColor: 'rgba(255,255,255,0.06)',
  },
  // Card de post otimista (recém-criado, aguardando confirmação do servidor).
  optimistic: { opacity: 0.55 },
  postHeaderRow: { flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' },
  topicBadge: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 5,
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 8,
    maxWidth: '80%',
  },
  topicIcon: { fontSize: 12 },
  topicText: { fontSize: 12, fontWeight: '700' },
  postTitle: { fontSize: 15, fontWeight: '700', lineHeight: 20 },
  postBody: { fontSize: 13, lineHeight: 18 },
  postMeta: { fontSize: 12, fontWeight: '600' },

  // Linha com thumbnail + textos (posts de mídia)
  mediaRow: { flexDirection: 'row', gap: 12, alignItems: 'flex-start' },
  mediaThumbWrap: {
    width: 88,
    aspectRatio: 16 / 9,
    borderRadius: 8,
    overflow: 'hidden',
    backgroundColor: '#000',
    position: 'relative',
  },
  mediaThumbImg: { width: '100%', height: '100%' },
  mediaTypeBadge: {
    position: 'absolute',
    top: 4, left: 4,
    backgroundColor: 'rgba(0,0,0,0.65)',
    borderRadius: 6,
    paddingHorizontal: 5,
    paddingVertical: 2,
    flexDirection: 'row',
    alignItems: 'center',
    gap: 2,
  },
  mediaTypeBadgeText: { color: '#FFFFFF', fontSize: 9, fontWeight: '700' },
  mediaTextCol: { flex: 1, gap: 4 },

  // ── Card de vídeo ──
  videoCard: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
    borderRadius: 14,
    padding: 10,
    borderWidth: 1,
    borderColor: 'rgba(255,255,255,0.06)',
  },
  videoThumbWrap: { width: 120, height: 68, borderRadius: 10, overflow: 'hidden', backgroundColor: '#1E2029' },
  videoThumb: { width: '100%', height: '100%' },
  thumbPlaceholder: { justifyContent: 'center', alignItems: 'center', backgroundColor: '#252832' },
  thumbPlaceholderIcon: { fontSize: 26, color: 'rgba(255,255,255,0.85)' },
  durationPill: {
    position: 'absolute',
    bottom: 6,
    right: 6,
    backgroundColor: 'rgba(0,0,0,0.8)',
    paddingHorizontal: 5,
    paddingVertical: 2,
    borderRadius: 4,
  },
  durationText: { fontSize: 10, fontWeight: '700', color: '#FFFFFF' },
  videoInfo: { flex: 1, gap: 4 },
  videoTitle: { fontSize: 14, fontWeight: '600', lineHeight: 18 },
  videoMeta: { fontSize: 12, fontWeight: '600' },

  // ── Ação de apagar (só dono) ──
  deleteBtn: { padding: 4 },
  videoDeleteBtn: { padding: 6, alignSelf: 'flex-start' },

  // ── Carregar mais ──
  loadMore: { alignItems: 'center', paddingVertical: 12 },
  loadMoreText: { fontSize: 14, fontWeight: '700' },
});
